<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Button
    v-bind="$props"
    :ui="{
      ...$props.ui,
      button: [
        'epk-button',
        { 'epk-button_loading': $props.isLoading },
        $props.ui?.button,
      ],
    }"
    @click="handleClick"
  >
    <template v-if="$slots.before" #before><slot name="before" /></template>
    <template #loading>
      <slot name="loading">
        <svg
          class="epk-button__loader"
          width="22px"
          height="22px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="epk-button__loader__circle-bg"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          />
          <circle
            class="epk-button__loader__circle"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          />
        </svg>
      </slot>
      <div class="epk-button__loader-default">
        <slot style="display: none" />
      </div>
    </template>
    <template v-if="$slots.default" #default><slot /></template>
    <template v-if="$slots.after" #after><slot name="after" /></template>
  </Button>
</template>

<script setup lang="ts">
import { Button, type ButtonProps } from '@mkskom/ui';

export interface IButtonProps extends /* @vue-ignore */ ButtonProps {
  isLoading?: boolean;
  fontWeight?: number;
  padding?: string | number;
}

const props = defineProps<IButtonProps>();

const emit = defineEmits<{
  (e: 'click', value: Event): void;
}>();

const handleClick = (e: Event) => (!props.isLoading ? emit('click', e) : '');
</script>

<style lang="scss">
@import './Button';
</style>
